<template>
  <div id="app">
    <app-header />
    <div class="container">
      <router-view :isdistcountry="isdistcountry" />
    </div>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import ApiService from "@/js/ApiService.js";

export default {
  name: 'app',
  cookieName: 'countrycode',

  components: {
    AppHeader,
    AppFooter
  },

  data() {
    return {
      showModal: false,
      countrycode: '',
      affiliateId: '',
      defaultcountry: 'world',
      distcountry: {
        'at': true,
        'au': true,
        'be': true,
        'by': true,
        'cn': true,
        'cr': true,
        'dk': true,
        'fr': true,
        'de': true,
        'gr': true,
        'hk': true,
        'il': true,
        'in': true,
        'it': true,
        'kr': true,
        'kz': true,
        'lu': true,
        'mo': true,
        'mc': true,
        'nl': true,
        'nz': true,
        'pl': true,
        'ru': true,
        'es': true,
        'za': true,
        'ch': true,
        'tr': true,
        'ua': true,
        'th': true,
        'se': true,
        'ic': true,
        'fi': true,
        'ee': true,
        'lv': true,
        'lt': true,
        'sa': true,
        'ae': true,
        'om': true,
        'qa': true,
        'bh': true,
        'kw': true,
        'pt': true,
        'tw': true,
      }
    }
  },

  computed: {
    isdistcountry() {
      if(!this.countrycode) return true;
      return this.distcountry[this.countrycode] ? true : false;
    }
  },

  created() {
    this.$watch(
      () => this.$route.query,
      () => {
        this.isAffiliateReferral();
      }
    )
    this.getGeoCookie(this.$options.cookieName);
    if (!this.countrycode) {
      ApiService.getCountryCode()
      .then(response => {
        this.onSuccess(response);
      })
      .catch(error => {
        this.onError(error);
        this.setGeoCookie(this.$options.cookieName, 'world', '1d');
      })
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.isAffiliateReferral();
    })
  },

  methods: {
    setGeoCookie(cname, cvalue, expire) {
      return this.$cookies.set(cname, cvalue, expire);
    },

    getGeoCookie(cname) {
      const cookieVal = this.$cookies.get(cname);
      return ( cookieVal ? this.countrycode = cookieVal : this.countrycode = '');
    },

    onSuccess(response) {
      if (response.data.haserror === true) {
        console.error(`Geolocation lookup error: ${response.data.errormessage}`);
        this.countrycode = 'world';
        this.setGeoCookie(this.$options.cookieName, 'world', '1d');
      } else {
        this.countrycode = response.data.country_iso.toLowerCase();
        this.setGeoCookie(this.$options.cookieName, this.countrycode, '1d');
      }
    },

    onError(error) {
      console.error(`Geolocation API Service unreachable: ${error}`);
    },

    isAffiliateReferral() {
      let idString = this.$route.query.bbAffiliateID;
      if ( idString !== undefined && idString !== null && idString !== "" ) {
        idString = idString.replace(/[^0-9a-zA-Z]/g,'');
        this.affiliateId = idString;
        this.checkForAffiliateCookie();
      }
    },

    checkForAffiliateCookie() {
      const cookieVal = this.$cookies.get("affiliate");
      if (!cookieVal || cookieVal===null || cookieVal==="expired") {
        this.setAffiliateIdCookie();
      }
    },

    setAffiliateIdCookie() {
      this.$cookies.set("affiliate", this.affiliateId, "30d");
    },
  }
};
</script>

<style lang="scss">
@import url("https://use.typekit.net/ehs0itc.css");
@import url("https://fonts.googleapis.com/css?family=Roboto:400,500&display=swap");

@font-face {
  font-family: "bryantpro_medium";
  src: url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.eot");
  src: url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.eot?#iefix")
      format("embedded-opentype"),
    url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.woff2")
      format("woff2"),
    url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.woff")
      format("woff"),
    url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.ttf")
      format("truetype"),
    url("https://s3.amazonaws.com/s3.pilates.com/fonts/bryantpro-medium-webfont.svg#bryantpro_medium")
      format("svg");
  font-weight: normal;
  font-style: normal;
}

:root {
  --black: #000000;
  --white: #ffffff;
  --roboto: "Roboto", Helvetica, Arial, sans-serif;
  --bryant: "bryantpro_medium", Helvetica, Arial, sans-serif;
  --noto: "noto-serif", "Times New Roman", Times, serif;
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  background-image: url(https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/sandpaper.png);
  margin: 0;
  font-family: var(--roboto);
}

.container {
  border-style: solid;
  border-width: 61px;
  border-image: url(https://s3.amazonaws.com/s3.pilates.com/img/landing-pages/contrology/border_contrology.svg) 61 round;
  margin: 0 3%;
}

main {
  margin-left: -50px;
  margin-right: -50px;
  margin-top: -20px;
  padding: 0 20px;
  overflow: hidden;
}

h1 {
  font-family: var(--noto);
  text-transform: uppercase;
  font-weight: 200;
  font-size: 1.5rem;
  line-height: 1.167;
  color: #333;
  letter-spacing: 0.04em;
}

h2 {
  font-family: var(--noto);
  text-transform: uppercase;
  font-size: 1.625rem;
  font-weight: 400;
  line-height: 1.192;
  color: #333;
}

h3 {
  font-family: var(--noto);
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.5;
  color: #333;
  text-align: center;
}

a {
  color: #000000;
}

@media only screen and (min-width: 955px) {
  h1 {
    font-size: 2.125rem;
    line-height: 1.176;
  }
}
</style>
